import React, { useEffect, useState } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import { getPlants } from "../../../../services/production/productionService";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";

function SearchPlant({ onSelectPlant }) {
  const [plants, setPlants] = useState([]);
  const getPlantsData = async () => {
    const response = await getPlants();
    const { data } = response.data;
    setPlants(data.plants);
  };
  useEffect(() => {
    getPlantsData();
  }, []);
  return (
    <React.Fragment>
      <CustomDataTableSearch
        data={plants}
        onRefreshData={() => {
          getPlantsData();
        }}
        onSelectedData={(rowData, originalEvent) => {
          onSelectPlant(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectPlant(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Plant ID",
            field: "ID",
            body: null,
            sortable: true,
          },
          {
            header: "Plant",
            field: "plantName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.plantName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "Phone Number",
            field: "addressPhone",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.addressPhone} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "City",
            field: "city",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.city} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
        ]}
      />
    </React.Fragment>
  );
}

export default SearchPlant;
